var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDrink = function SvgDrink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 84 84"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#drink_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    x: 16,
    y: 12,
    fill: "#fff",
    rx: 8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F4970",
    d: "M49.945 28.3a.8.8 0 0 0-.792-.625h-6.33l-.084.083v-2.874l4.915-1.666 1.79-.625c.417-.166.667-.624.5-1.041-.166-.417-.624-.666-1.04-.5l-7.249 2.5c-.333.125-.583.416-.583.791v3.416h-6.414a.8.8 0 0 0-.791.624l-.833 2.958c-.084.25 0 .5.124.708.125.208.417.333.667.333h.042l1.29 21.827c.042.458.376.791.834.791h11.83c.458 0 .79-.333.833-.791l1.29-21.827h.042c.25 0 .5-.125.667-.333a.73.73 0 0 0 .125-.708zM36.782 53.292l-1.25-20.952H48.28l-1.25 20.952zm-1.5-23.91H48.53l.374 1.292H34.909z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "drink_svg__a",
    width: 84,
    height: 84,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.745833 0 0 0 0 0.745833 0 0 0 0 0.745833 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2710_35456"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2710_35456",
    result: "shape"
  })))));
};
export default SvgDrink;